module.exports = __webpack_public_path__ + "img/15.a12df4c5.jpg";